import { useEffect, useRef } from 'react';
import { convertSchemaFormsToDynamicFormStoreState } from '../helpers';
import { useNonReactiveDynamicFormStore } from '../store';
import type { SchemaForm } from '../types';

/** Must be called inside DynamicFormStoreProvider. Syncs schema changes into the store after mount. */
export const useDynamicFormSchemaSyncer = (schemaForms: SchemaForm[]) => {
  const store = useNonReactiveDynamicFormStore();
  const isMountedRef = useRef(false);

  useEffect(() => {
    if (!isMountedRef.current) {
      isMountedRef.current = true;
      return;
    }
    store.getState().syncSchema(convertSchemaFormsToDynamicFormStoreState(schemaForms));
  }, [schemaForms, store]);
};
